export default __webpack_public_path__ + "static/media/deaths.283a0dc5.svg";